export class UserAttribute {
    public userAttributeID: number = 0;
    public name: string = '';
    public desc: string = '';
    public label: string = '';
    public attributeType: string = '';
    public attributeCode: string = '';
    public attributeRequired?: any;
    public attributeValue?: any;
    public userAttributeDocument?: any;
    public isPresent: boolean = false;
}